{
  "button-bar-for-selected-service": {
    "text": {
      "and-x-more": "et {{nr}} plus",
      "duration": "Durée",
      "select-service-hint": "Veuillez sélectionner au moins un service et la date et l'heure souhaitées pour continuer"
    }
  }
}
